<div
    *transloco="let t"
    [class]="'bazis-input-file bazis-control ' + cssClassSizeControl"
>
    @for (file of files; track file.id; let fileIndex = $index) {
        <div class="tms-uploader__files">
            <div
                class="bazis-control__field-group"
                [class.bazis-control__field-group--disabled]="isDisabled"
            >
                <div class="bazis-control__field bh-overhide">
                    <div class="bazis-file-inline">
                        <bazis-icon
                            color="danger"
                            name="document"
                            class="bh-shrink"
                        ></bazis-icon>
                        <div class="bh-flex-column bh-overhide">
                            <div class="bh-ellipsis bh-block">
                                {{ file.file.name }}
                            </div>
                            <div class="bazis-text_minor bazis-text_secondary">
                                .{{ file.extension }}
                                {{ file.file.size | fileSize }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bazis-control__field-group__end">
                    @if (!isDisabled) {
                        <app-button-tooltip
                            icon="trash"
                            color="danger"
                            size="compact"
                            tooltipKey="action.delete"
                            (actionClick)="removeFile(fileIndex)"
                        ></app-button-tooltip>
                    }
                </div>
            </div>
        </div>
    }

    @if (files.length < max && !isDisabled) {
        <div class="bazis-block bazis-block_hoverable">
            <div class="bh-flex">
                <bazis-icon src="/assets/icons/big/doc.svg"></bazis-icon>
                <bazis-icon
                    class="active"
                    src="/assets/icons/big/doc-active.svg"
                ></bazis-icon>
                <div>
                    <span [innerHTML]="t('form.file.title')"> </span>

                    <p class="bazis-p_minor">
                        {{ t('form.title.inputFile.allowedFormats') }}
                        @for (
                            allowedExtension of displayAllowedExtentions;
                            track $index;
                            let i = $index
                        ) {
                            {{ (i > 0 ? ', ' : '') + allowedExtension }}
                        }
                    </p>
                </div>
            </div>
            <input
                type="file"
                [attr.multiple]="max > 1"
                (focus)="markAsTouched()"
                (change)="addFiles($event)"
            />
        </div>
    }
    <ng-content></ng-content>
</div>
